module.exports = __webpack_public_path__ + "static/img/service_passprime_icon_3.466e3e07.svg";